import { Button, Checkbox, FileAttachment, MimeTypes, Typography } from "best-common-react";
import React from "react";
import { CSVLink } from "react-csv";
import styled from "styled-components";
import { MetadataConstants } from "../../../constants/MetadataConstants";
import { useAuth } from "../../../contexts/AuthContext";
import { useUploads } from "../../../contexts/UploadContext";
import UploadStatuses from "./UploadStatuses";

const UploadContainer = styled.div.attrs({
  className: "bcr-me-2",
})`
  display: flex;
  align-items: start;
  width: 100%;
`;

const StraightToFinalContainer = styled.div`
  width: 10rem;
  display: flex;
  align-items: center;
  padding-top: 0.5rem;
  margin-left: 2rem;
`;

const MultiFileUpload = () => {
  const { isAdmin } = useAuth();
  const { multiFile, setMultiFileData, upload, canSave, straightToFinal, setStraightToFinal } = useUploads();

  return (
    <div className="bcr-p-2">
      <Typography variant="titleLarge">Multi File Upload</Typography>
      <div className="bcr-mb-3">
        <CSVLink className="bcr-me-3" filename="DomesticTemplate.csv" data={MetadataConstants.DOMESTIC} target="_blank">
          Domestic Template
        </CSVLink>
        <CSVLink filename="InternationalTemplate.csv" data={MetadataConstants.INTERNATIONAL} target="_blank">
          International Template
        </CSVLink>
      </div>
      <UploadContainer>
        <div style={{ width: "100%" }}>
          <FileAttachment
            id="multi-file-upload"
            maxFiles={1}
            onChange={setMultiFileData}
            fileTypes={[MimeTypes[".xlsx"], MimeTypes[".xls"], MimeTypes[".csv"]]}
            files={!!multiFile ? [multiFile] : []}
          />
        </div>
        <Button variant="primary" className="bcr-ms-2" onClick={upload} disabled={!canSave}>
          Upload
        </Button>
        {!!isAdmin && (
          <StraightToFinalContainer>
            <Checkbox
              label="Straight to final"
              id="straightToFinal"
              className="bcr-me-2"
              checked={!!straightToFinal}
              onChange={() => {
                setStraightToFinal(!straightToFinal);
              }}
            />
          </StraightToFinalContainer>
        )}
      </UploadContainer>
      <div className="bcr-mb-3">
        <UploadStatuses />
      </div>
    </div>
  );
};

export default MultiFileUpload;
